import * as React from 'react';
export const SuperRiskProfileGaugeSix = (
  props: React.SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg viewBox="0 0 44 23" fill="none" {...props}>
    <g clipPath="url(#prefix__clip0_8760_10248)">
      <path
        d="M.001 21.974a22 22 0 012.092-9.165l9.954 4.683A11 11 0 0011 22.074l-11-.1zM2.267 12.45A22 22 0 018.128 5.1l6.936 8.537a11 11 0 00-2.93 3.675l-9.867-4.863zM8.441 4.85a22 22 0 018.47-4.079l2.545 10.702a11 11 0 00-4.235 2.04L8.44 4.85zM17.3.682a22 22 0 019.4 0l-2.35 10.746a10.998 10.998 0 00-4.7 0L17.3.682zM27.09.771a22 22 0 018.47 4.079l-6.78 8.662a10.998 10.998 0 00-4.235-2.04L27.09.771zM35.872 5.1a21.999 21.999 0 015.86 7.35l-9.866 4.862a11 11 0 00-2.93-3.675L35.871 5.1z"
        fill="#930EFF"
      />
      <path
        d="M41.908 12.81a22 22 0 012.091 9.164l-10.999.1a11.002 11.002 0 00-1.046-4.583l9.954-4.682z"
        fill="#E3E1E8"
      />
      <g filter="url(#prefix__filter0_d_8760_10248)">
        <path
          d="M30.941 14.938c.11-.117-.034-.295-.171-.212l-6.606 3.96a.344.344 0 00-.108.102l-2.061 3.03a.138.138 0 00.166.204l3.395-1.376a.346.346 0 00.122-.084l5.263-5.624z"
          fill="#12003B"
        />
      </g>
    </g>
    <defs>
      <clipPath id="prefix__clip0_8760_10248">
        <path fill="#fff" transform="translate(0 .174)" d="M0 0h44v22H0z" />
      </clipPath>
      <filter
        id="prefix__filter0_d_8760_10248"
        x={21.971}
        y={14.705}
        width={9.079}
        height={7.466}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx={0.069} dy={0.138} />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend
          in2="BackgroundImageFix"
          result="effect1_dropShadow_8760_10248"
        />
        <feBlend
          in="SourceGraphic"
          in2="effect1_dropShadow_8760_10248"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
